import { useState } from "react";

import { AutoExpandingTextarea } from "./AutoExpandingTextarea";
import LinkAddModal from "../../../views/TaskDetail/Link/LinkAddModal";
import ToolTip from "../Tooltip";

import styles from "../ProjectCreate.module.css";

import bookmarkDefaultImg from "../../../assets/Wiki/project-detail-bookmark-add.png";

export function ProjectInfo({
  data,
  onChangeSpaceTitle,
  onChangeSpaceDescription,
  handleDeleteBookmark,
  handleUpdateBookmark,
}) {
  const [visibleTooltipIndex, setVisibleTooltipIndex] = useState(null);
  const [iconPos, setIconPos] = useState(-100);

  const [isResourceAddModal, setIsResourceAddModal] = useState(false);

  const handleResourceAdd = async () => {
    setIsResourceAddModal(true);
  };

  const handleIconEnter = (index) => (e) => {
    const rect = e.target.getBoundingClientRect();
    const centerY = rect.top + rect.height / 2;
    setVisibleTooltipIndex(index);
    setIconPos(centerY);
  };

  const handleIconLeave = (e) => {
    setVisibleTooltipIndex(null);
    setIconPos(-100);
  };

  const handleMove = (url) => () => {
    if (url.startsWith("http://") || url.startsWith("https://")) {
      window.open(url, "_blank");
    } else {
      window.open("https://" + url, "_blank");
    }
  };

  return (
    <>
      <div className={styles.project__info}>
        <input
          type="text"
          className={styles.projectUntitle}
          placeholder="Untitled Project"
          value={data?.title}
          onChange={onChangeSpaceTitle}
        />

        <AutoExpandingTextarea
          field="description"
          dataChange={onChangeSpaceDescription}
          description={data?.description}
        />
        <div className={styles.project__line}></div>
        <span className={styles.bookmark__title}>Bookmarks</span>

        <div className={styles["setting-property-resource"]}>
          {data &&
            data.bookmarks &&
            data.bookmarks.map((item, index) => (
              <div
                key={index}
                className={styles["resource-item"]}
                onMouseEnter={handleIconEnter(index)}
                onMouseLeave={handleIconLeave}
                onClick={handleMove(item?.link)}
              >
                <div
                  className={styles["resource-item-favicon"]}
                  style={{
                    backgroundImage: `url(https://www.google.com/s2/favicons?sz=64&domain_url=${item.link})`,
                  }}
                ></div>
                <div
                  className={styles["resource-item-delete"]}
                  style={{
                    visibility: `${visibleTooltipIndex === index ? "visible" : "hidden"}`,
                  }}
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteBookmark(index);
                  }}
                ></div>
                <ToolTip
                  key={index}
                  text={item.title}
                  isVisible={visibleTooltipIndex === index}
                  style={{ top: `${iconPos}px` }}
                />
              </div>
            ))}
          <div
            className={styles["resource-item"]}
            onClick={handleResourceAdd}
          >
            <img
              className={styles.bookmark__default}
              src={bookmarkDefaultImg}
            />
          </div>
        </div>
      </div>
      {isResourceAddModal && (
        <LinkAddModal
          onSave={(key, value) => handleUpdateBookmark(key, value)}
          onClose={() => setIsResourceAddModal(false)}
        />
      )}
    </>
  );
}
